import { TrapInteractor, TrapRequest, TrapStructRequest } from "../../Coordinator/Trap/TrapInteractor";

export class TrapViewModel {
	private interactor: TrapInteractor;

	constructor() {
		this.interactor = new TrapInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new TrapRequest(
			obj["sgepdenguearmadilha"] ? parseInt(obj["sgepdenguearmadilha"]) : 0,
			obj["nome"] ? obj["nome"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new TrapStructRequest(obj["sgepdenguearmadilha"] ? parseInt(obj["sgepdenguearmadilha"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}